import { withNamespace } from '../helper';

const namespace = '@BRAND';

export const GET_BRAND = withNamespace('GET_BRAND', namespace);
export const GET_BRAND_SUCCESS = withNamespace('GET_BRAND_SUCCESS', namespace);

export const GET_BRANDS = withNamespace('GET_BRANDS', namespace);
export const GET_BRANDS_SUCCESS = withNamespace('GET_BRANDS_SUCCESS', namespace);
